var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.vm.modalTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.rm
                    ? _c(
                        "form",
                        {
                          attrs: { id: "settingsForm" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.onFormSubmit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-group col" }, [
                              _c("label", [_vm._v("Plan name:")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.rm.Name,
                                    expression: "rm.Name",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  required: "",
                                  minlength: "2",
                                },
                                domProps: { value: _vm.rm.Name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.rm,
                                      "Name",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group col" }, [
                              _c("label", [_vm._v("Link to Enterprise Plan:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.corporateScenarioId,
                                      expression: "corporateScenarioId",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: _vm.rm.IsActive },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.corporateScenarioId = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null },
                                    },
                                    [_vm._v("Choose...")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.rm.CorporateScenarios,
                                    function (cs) {
                                      return _c(
                                        "option",
                                        { domProps: { value: cs.Id } },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(cs.Name) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.rm.IsActive
                                ? _c(
                                    "small",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        "\n                                    This cannot be changed because the plan is currently active in that enterprise plan.\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", [_vm._v("Description:")]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.rm.Description,
                                  expression: "rm.Description",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              domProps: { value: _vm.rm.Description },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.rm,
                                    "Description",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-group col" }, [
                              _c("label", { attrs: { for: "denomination" } }, [
                                _vm._v("Currency denomination:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.rm.Denomination,
                                      expression: "rm.Denomination",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "denomination" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.rm,
                                        "Denomination",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "Unit" } }, [
                                    _vm._v("Unit"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Thousand" } },
                                    [_vm._v("Thousand")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Million" } },
                                    [_vm._v("Million")]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group col" }, [
                              _c("label", [_vm._v("Risk adjusted benefits:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.rm.ApplyBenefitsConfidenceFactor,
                                      expression:
                                        "rm.ApplyBenefitsConfidenceFactor",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.rm,
                                        "ApplyBenefitsConfidenceFactor",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: true } }, [
                                    _vm._v("Enabled"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { domProps: { value: false } }, [
                                    _vm._v("Disabled"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [_vm._v("Value definition")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Goal:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.criteriaHierarchyId,
                                      expression: "criteriaHierarchyId",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.criteriaHierarchyId = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v("Choose..."),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.rm.ValueDefinitions,
                                    function (ch) {
                                      return _c(
                                        "option",
                                        { domProps: { value: ch.Id } },
                                        [_vm._v(_vm._s(ch.Name))]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Weights set:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.weightsSetId,
                                      expression: "weightsSetId",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.weightsSetId = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v("Default"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.weightsSets, function (ws) {
                                    return _c(
                                      "option",
                                      { domProps: { value: ws.Id } },
                                      [_vm._v(_vm._s(ws.Name))]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("fieldset", [
                            _c("legend", [_vm._v("Approval")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Accepted:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.rm.ApprovalAcceptedStatusId,
                                      expression: "rm.ApprovalAcceptedStatusId",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.rm,
                                        "ApprovalAcceptedStatusId",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v("Do not change"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.rm.Statuses, function (s) {
                                    return _c(
                                      "option",
                                      { domProps: { value: s.Id } },
                                      [_vm._v(_vm._s(s.Name))]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    "\n                                    Kanban status for Accepted projects. The Kanban status will be updated when you Approve your decision in the scenario.\n                                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Rejected:")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.rm.ApprovalRejectedStatusId,
                                      expression: "rm.ApprovalRejectedStatusId",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.rm,
                                        "ApprovalRejectedStatusId",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v("Do not change"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.rm.Statuses, function (s) {
                                    return _c(
                                      "option",
                                      { domProps: { value: s.Id } },
                                      [_vm._v(_vm._s(s.Name))]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    "\n                                    Kanban status for Rejected projects. The Kanban status will be updated when you Approve your decision in the scenario.\n                                "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", form: "settingsForm" },
                    },
                    [_vm._v("Confirm")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }